import { useEffect, useState } from 'react';
import { getFacilities } from './useFacilities';
import { getMarkets } from './useMarkets';

export function usePackageLocationSelection(organizationId, numericIds = false) {
  const [markets, setMarkets] = useState<any[]>([]);
  const [facilities, setFacilities] = useState<any[]>([]);
  const [marketId, setMarketId] = useState<any>('');
  const [facilityId, setFacilityId] = useState<any>('');

  useEffect(() => {
    let active = true;
    setMarkets([]);
    setFacilities([]);
    setMarketId('');
    setFacilityId('');

    if (organizationId) {
      getMarkets(organizationId)
        .then((nextMarkets) => {
          if (active) setMarkets(Array.isArray(nextMarkets) ? nextMarkets : []);
        })
        .catch((error) => {
          if (active) console.log(error);
        });
    }

    return () => { active = false; };
  }, [organizationId]);

  useEffect(() => {
    let active = true;
    setFacilities([]);
    setFacilityId('');

    if (organizationId && marketId) {
      getFacilities(organizationId, marketId)
        .then((nextFacilities) => {
          if (active) setFacilities((Array.isArray(nextFacilities) ? nextFacilities : []).filter(facility => facility.active));
        })
        .catch((error) => {
          if (active) console.log(error);
        });
    }

    return () => { active = false; };
  }, [organizationId, marketId]);

  const selectMarket = (value: string) => {
    setFacilities([]);
    setFacilityId('');
    setMarketId(numericIds && value ? Number.parseInt(value, 10) : value);
  };
  const selectFacility = (value: string) => {
    setFacilityId(numericIds && value ? Number.parseInt(value, 10) : value);
  };

  return { markets, facilities, marketId, facilityId, selectMarket, selectFacility };
}
